<script lang="ts">
    import { get } from "lodash"
    import { createEventDispatcher } from "svelte"
    import { tooltip } from "../../functions/tooltip"
    import TaskType from "./fields/TaskType.svelte"
    import DateTime from "./fields/DateTime.svelte"
    import TaskProtcol from "./fields/TaskProtcol.svelte"
    import TaskFileDownloads from "./fields/TaskFileDownloads.svelte"
    import StepsCompleted from "./fields/StepsCompleted.svelte"
    import TaskPhotos from "./fields/TaskPhotos.svelte"
    import Action from "./fields/Action.svelte"
    import AssignedPeople from "./fields/AssignedPeople.svelte"
    import { login } from "../../store"
    import Status from "./fields/Status.svelte"

    export let gridview = false
    export let className = ""
    export let roundedHeader = false
    export let rows: TableRow[]
    export let columns: TableColumn[] = [
        {
            label: "",
            component: TaskType,
            field: "taskType",
            className: "w-40 max-w-40 dark-on-mobile",
            getProps(r: TableRow, field: string) {
                return { type: get(r, field), gridview: gridview, orderId: r.orderId, taskId: r.id }
            },
        },
        {
            label: "Einsatz-Start",
            field: "timeframe.start",
            component: DateTime,
            className: "w-200",
            getProps(r: TableRow, field: string) {
                return { datetime: get(r, field) }
            },
        },
        {
            label: "Kurzbeschreibung",
            field: "generalDetails.shortDescription",
            className: "w-140 text-wrap",
        },
        {
            label: "angelegt von",
            field: "meta.createdBy.name",
            className: "w-60",
        },
        {
            label: "Zuständig",
            component: AssignedPeople,
            className: "w-60",
            getProps(r: TableRow) {
                return { task: r }
            },
        },
        {
            label: "Status",
            component: Status,
            className: "w-60",
            getProps(r: TableRow) {
                return { task: r }
            },
        },
        {
            label: "bestätigt      Fortschritt",
            component: StepsCompleted,
            className: "w-400",
            getProps(r: TableRow) {
                return { task: r }
            },
        },
        {
            label: "Fotos",
            component: TaskPhotos,
            getProps(r: TableRow) {
                return { task: r }
            },
        },

        {
            label: "Einsatzprotokoll",
            component: TaskProtcol,
            getProps(r: TableRow) {
                return { task: r }
            },
        },
        {
            label: "Downloads",
            component: TaskFileDownloads,
            getProps(r: TableRow) {
                return { task: r }
            },
        },
        {
            label: "Aktionen",
            className: "w-80 max-w-80",
            component: Action,
            getProps(r: TableRow) {
                return { task: r }
            },
        },
    ]

    const dispatch = createEventDispatcher()

    let outerWidth: number
    const gridBreakPoint = 1200
    $: gridview = outerWidth <= gridBreakPoint
</script>

<svelte:window bind:innerWidth="{outerWidth}" />
<div
    class="table {className}  op-table"
    class:tableview="{!gridview}"
    class:gridview="{gridview}"
>
    {#each rows as task, i (task.id)}
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        {#if i == 0}
            <div
                class="tablerow thead default"
                class:roundedHeader="{roundedHeader}"
                data-cy="table-header"
                on:keydown
            >
                {#each columns as col}
                    {#if !col.hide}
                        <!-- svelte-ignore a11y-no-static-element-interactions -->
                        <div class="col {col.className || ''}">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <!-- svelte-ignore a11y-no-static-element-interactions -->
                            <div class="cell_inner">
                                <!-- svelte-ignore a11y-no-static-element-interactions -->
                                {@html col.label}
                            </div>
                        </div>
                    {/if}
                {/each}
            </div>
        {/if}
        <!-- svelte-ignore a11y-click-events-have-key-events -->

        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="tablerow {i % 2 == 1 ? 'odd' : 'even'} trow open"
            on:click="{() => dispatch('click', task)}"
            class:blockBecauseCompleted="{task?.status === 'completed' && !$login?.user?.roles?.includes('admin')}"
        >
            {#each columns || [] as col}
                {#if !col.hide}
                    <div
                        class:no-label="{!col.label}"
                        class="col {col.className || ''}"
                    >
                        {#if gridview}
                            <span class="label">{col.mobileLabel || col.label}</span>
                        {/if}
                        {#if col.component}
                            <svelte:component
                                this="{col.component}"
                                on:taskDeleted="{() => {
                                    delete rows[i]
                                    rows = rows.filter(Boolean)
                                }}"
                                {...(col.getProps && col.getProps(task, col.field)) || []}
                            />
                        {:else}
                            <div
                                style="width: 100%;"
                                class="text-wrap"
                            >
                                {get(task, col.field)}
                            </div>
                        {/if}
                    </div>
                {/if}
            {/each}
        </div>
    {/each}
</div>

<style lang="less">
    .hide {
        display: none;
    }
    .roundedHeader {
        padding: 0.9rem 1.2rem;
        background: var(--text-100);
        border-radius: 1rem 1rem 0px 0px;
        * {
            color: white !important;
            font-weight: 700 !important;
        }
    }
</style>
